<template>
  <div style="float: left;">
    <div class="starkbox">
      <div class="star-list">
        <span v-for="item in [1,2,3,4,5]" />
      </div>
      <div class="star-list star-list-post" :style="{width:starNumEnd + 'px'}">
        <span class="active" v-for="item in [1,2,3,4,5]" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      starNum: {
        type: Number,
        default: 5
      }
    },
    computed: {
      starNumEnd() {
        return this.calpreWidth(this.starNum);
      }
    },
    methods: {
      calpreWidth: function (scoreNum) {
        if (scoreNum === 0) {
          return 0;
        }
        let qujian = [0, 22, 44, 66, 88];
        let socre = Number(scoreNum).toFixed(2);
        let scorel = socre.split(".")[0];
        let scorer = socre.split(".")[1];
        let precentArea = Math.ceil(scorer / 100 * 14);
        if (scorer * 1 === 0) {
          scorel -= 1;
          precentArea = 15;
        }
        return qujian[scorel] + precentArea;
      }
    }
  };
</script>

<style lang="less" scoped>
  .starkbox {
    unicode-bidi: bidi-override;
    color: #e8e9f3;
    font-size: 0;
    float: left;
    margin: 0 auto;
    position: relative;
    display: table;
    padding: 0;

    .star-list {
      span {
        font-size: 14px;
        position: relative;
        color: #e8e9f3;
        margin-right: 8px;

        &.active {
          color: #ffdc0d;
        }

        &::after {
          content: "★";
        }
      }
    }

    .star-list-post {
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      white-space: nowrap;
    }
  }
</style>




// WEBPACK FOOTER //
// valuationStar.vue?bcf2a984